import { HCP_CUBE_NAME } from '@/api/hcp/interaction/types';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { FilterConfigDynamic } from '@/types/filter';

const DIMENSION = `${HCP_CUBE_NAME}.country_legal_basis_tier`;

const consentTierFilter: FilterConfigDynamic = {
  label: 'main.aggregatedConsent.filters.tier.label',
  placeholder: 'main.aggregatedConsent.filters.tier.placeholder',
  type: 'multiselect',
  defaultValue: [],
  clearable: true,
  useFloatingLabel: true,
  sourceCube: HCP_CUBE_NAME,
  getOptionsQuery: () => ({
    dimensions: [DIMENSION],
    limit: 1000,
    filters: [],
  }),
  mapResult: mapDimensionToOption(DIMENSION),
  applyFilter: value => {
    const v = value as string[];
    if (!v?.length) return undefined;
    return { member: DIMENSION, operator: 'equals', values: [...v] };
  },
};

export default consentTierFilter;
